export enum CourseTypeEnum {
  Light = 'light',
  Advanced = 'advanced',
}
